export class ProfileSection {
    public static readonly INFORMASI_UTAMA: string = 'informasi-utama';
    public static readonly KONTAK_PRIBADI: string = 'kontak-pribadi';
    public static readonly DATA_PENDUKUNG: string = 'data-pendukung';
}